import axios from "axios";
import store from "../stores/index.js";
const API_KEY = process.env.VUE_APP_API_KEY;

const api = axios.create({
  headers: {
    "Content-Type": "application/json",
  },
});

const request = {
  get: (url, params) => api.get(url, { params }),
  post: (url, data) => api.post(url, data),
};

const requestWithKey = {
  post: (url, data) => {
    api.interceptors.request.use((config) => {
      const newConfig = config;
      newConfig.headers['API-KEY'] = API_KEY;
      newConfig.headers['X-STORE-CODE'] = store.state.common.storeData.storeCode;
      return newConfig;
    })
    return (data === null) ? api.post(url) : api.post(url, data);
  },
  get: (url, params) => {
    api.interceptors.request.use((config) => {
      const newConfig = config;
      newConfig.headers['API-KEY'] = API_KEY;
      newConfig.headers['X-STORE-CODE'] = store.state.common.storeData.storeCode;
      return newConfig;
    })
    return api.get(url, { params });
  },
}

export {request, requestWithKey};